
import Vue from 'vue'
import { placeToVisitApi, PlaceToVisitDto } from '@/api/placeToVisit'
import { formatAddress } from '@/utils/addresses'
import TitlePage from '@/components/TitlePage.vue'
import { handleAxiosException } from '@/api'
import HistoryToolTip from '@/components/HistoryToolTip.vue'
import PlaceToVisitDialog from './PlaceToVisitDialog.vue'

export default Vue.extend({
  components: { PlaceToVisitDialog, TitlePage, HistoryToolTip },
  data() {
    return {
      error: '',
      loading: false,
      editDialog: {
        active: false,
        placeToVisit: undefined as PlaceToVisitDto|undefined,
      },
      placesToVisit: [] as PlaceToVisitDto[],
      snackbarSuccessRegistration: {
        active: false,
        message: '',
      },
      lengthPagination: 1,
      infoDetails: [
        { key: 'phonenumber', icon: 'mdi-phone', formatter: (item) => item.phonenumber },
        { key: 'email', icon: 'mdi-at', formatter: (item) => item.email },
        { key: 'address', icon: 'mdi-map-marker', formatter: (item) => formatAddress(item.address, this.$i18n.locale) },
      ] as {key: string, formatter: (item: PlaceToVisitDto) => string, icon: string}[],
    }
  },
  methods: {
    formatAddress,
    setPage(page: number) {
      if (page !== this.page) {
        this.$router.push({ query: { page: page.toString() } })
      }
    },
    create() {
      this.editDialog = {
        active: true,
        placeToVisit: undefined,
      }
    },
    edit(p: PlaceToVisitDto) {
      this.editDialog = {
        placeToVisit: p,
        active: true,
      }
    },
    onSuccessSave(p: PlaceToVisitDto) {
      this.snackbarSuccessRegistration = {
        active: true,
        message: this.$t('success.save', { name: p.name ?? p.fullName }) as string,
      }
      this.editDialog.active = false
      this.loadData()
    },
    async loadData() {
      this.loading = true
      try {
        const page = (await placeToVisitApi.getAllPlacesToVisit({ page: this.page - 1, size: 10 }))
        this.lengthPagination = page.totalPages
        this.placesToVisit = page.content
      } catch (err) {
        this.error = this.$t(handleAxiosException(err, () => 'error.loading')) as string
      }
      this.loading = false
    },
  },
  computed: {
    page(): number {
      return parseInt(this.$route.query.page as string ?? '1', 10)
    },
  },
  watch: {
    page() {
      this.loadData()
    },
  },
  async mounted() {
    this.loadData()
  },
})
